"use client";

import { TrendingUp } from "lucide-react";

import { ItemCardRail } from "@/components/feed/item-card-rail";

/**
 * TrendingRail — the "Trending now" landing strip (mockup: Kraahl Desktop Home).
 * A thin wrapper over the shared ItemCardRail.
 *
 * TODO(v3): the data source is a placeholder (reuses "just-listed"); wire a real
 * trending query (most-saved / momentum) so it differs from the grid.
 */
export function TrendingRail({
  currentUserId,
  onSeeAll,
  className,
}: {
  currentUserId?: string;
  onSeeAll?: () => void;
  className?: string;
}) {
  return (
    <ItemCardRail
      title="Trending now"
      icon={TrendingUp}
      currentUserId={currentUserId}
      onSeeAll={onSeeAll}
      className={className}
    />
  );
}
